<template>
  <v-app :class="appClasses">
    <v-main>
        <ErrorBoundary>
            <router-view/>
        </ErrorBoundary>
    </v-main>
    <Navigator v-if="$store.getters.isLoggedIn" ref="navigator" @navigator-state-changed="onNavigatorStateChanged" />
    <AiChatDock v-if="$store.getters.isLoggedIn" />
  </v-app>
</template>
<script>
import {wlData} from './assets/js/constants';
import ErrorBoundary from './components/ErrorBoundary.vue';
import Navigator from './components/Navigator.vue';
import AiChatDock from './components/aiChat/AiChatDock.vue';
// set the page title and favicon
document.title = wlData.pageTitle||wlData.name;
export default {
  name: "App",
  components: {
    ErrorBoundary,
    Navigator,
    AiChatDock
  },
  
  data() {
    return {
      navigatorState: {
        isCollapsed: false,
        isVisible: false
      }
    }
  },
  
  computed: {
    appClasses() {
      const classes = [];
      if (this.$store.getters.isLoggedIn && this.navigatorState.isVisible) {
        classes.push('navigator-visible');
        if (this.navigatorState.isCollapsed) {
          classes.push('navigator-collapsed');
        }
      }
      return classes;
    }
  },
  async beforeCreate(){
    try {
      if(!LOGGING_ENABLED){
        console.log = () => {}
      }
      if(MODE_DEV_SERVER){
        console.warn('Webpack detected. Loading locals via /locals')
        await this.$store.dispatch('loadLocals');
      } else {
        this.$store.dispatch('localsThroughWindow')
      }
      // CSS vars need .v-application — apply in mounted. Only set Vuetify dark here.
      if (this.$vuetify) {
        this.$vuetify.theme.dark = this.$store.state.theme === 'dark';
      }
    } catch (error) {
      console.error(error);
    }
  },
  
  async mounted() {
    // Always re-apply after mount so --app-*-txt/bg land on .v-application (prod + dev).
    await this.$nextTick();
    this.applyThemeFromStore();
    // Set up modal detection
    this.setupModalDetection();
  },
  
  methods: {
    /**
     * Apply store theme to Vuetify + project CSS variables on .v-application.
     */
    applyThemeFromStore() {
      const theme = this.$store.state.theme || 'dark';
      const projectThemes = this.$store.state.project && this.$store.state.project.themes;
      if (projectThemes) {
        this.$store.dispatch('setCustomTheme', [theme, projectThemes]);
      } else {
        this.$store.dispatch('setDefaultTheme', theme);
      }
      this.$vuetify.theme.dark = theme === 'dark';
    },

    onNavigatorStateChanged(state) {
      this.navigatorState = { ...state };
    },
    
    setupModalDetection() {
      // Watch for Vuetify dialog overlays
      const observer = new MutationObserver((mutations) => {
        const hasModals = document.querySelector('.v-dialog--active, .v-overlay--active, .modal-overlay');
        this.$store.commit('setModalOpen', !!hasModals);
      });
      
      observer.observe(document.body, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class']
      });
      
      // Store reference to clean up later
      this.modalObserver = observer;
    }
  },
  
  beforeDestroy() {
    // Clean up modal observer
    if (this.modalObserver) {
      this.modalObserver.disconnect();
    }
  }
}
</script>
<style lang="scss">
  @import './assets/sass/global.sass';
</style>